import React from 'react';
import { cn } from '../../../../../../util/cn';
import BulletTextWrapper from '../CurrentPlan/BulletTextWrapper';

const AnnualSubcriptionCard = ({
    isSelected = false,
    noOfJobs,
    planAmt,
    setSelected,
    handleContinuePlan,
    noOfCredits = 0
}: any) => {

    const isDisabled = noOfCredits === noOfJobs;

    return (
        <div className="mt-3">
            <div
                className={cn(
                    "flex flex-col w-[280px] min-h-[210px] pt-[35px] font-bold pb-[30px] border-[1px] border-[rgba(138, 160, 174, 0.5)] rounded-[20px] items-center cursor-pointer",
                    {
                        "bg-gradient-to-r from-[#0B619A] to-[#4DAAE8]": isSelected && !isDisabled,
                        "bg-[#f1f1f1] cursor-not-allowed": isDisabled,
                    }
                )}
                onClick={() => {
                    if (!isDisabled) {
                        setSelected(noOfJobs);
                    }
                }}
            >

                <p
                    className={cn(
                        "mt-[10px] font-[Gilroy-Medium] text-center font-[400] text-[16px] leading-[19.41px]",
                        {
                            "text-[#15415E]": !isSelected || isDisabled,
                            "text-[#FFFFFF]": isSelected && !isDisabled,
                            "text-[#9ca3af]": isDisabled, // Tailwind's gray-400
                        }
                    )}
                >
                    <span className='font-[Gilroy-Bold] font-[400] text-[40px]'>{noOfJobs}</span>
                </p>

                <p
                    className={cn(
                        "mt-3 font-[Gilroy-Medium] text-center font-[400] text-[16px] leading-[19.41px]",
                        {
                            "text-[#15415E]": !isSelected || isDisabled,
                            "text-[#FFFFFF]": isSelected && !isDisabled,
                            "text-[#9ca3af]": isDisabled,
                        }
                    )}
                >
                    <span>30-day job Posting <br /> Per Month</span>
                </p>

                <div
                    className={cn(
                        "mt-1 mx-[30px] flex-1 flex flex-col gap-[15px] font-[Gilroy-Regular] font-[400] text-[12px] leading-[14.4px]",
                        {
                            "text-[#8AA0AE]": !isSelected || isDisabled,
                            "text-[#FFFFFF]": isSelected && !isDisabled,
                            "text-[#9ca3af]": isDisabled,
                        }
                    )}
                >
                    {/* Add your bullet list if needed */}
                </div>

                <button
                    disabled={isDisabled}
                    className={cn(
                        'h-[50px] mt-10 w-[210px] rounded-[70px] px-5 py-3 text-[16px] leading-[19.6px] font-[400] transition-all duration-200',
                        {
                            'bg-[#15415E] hover:bg-[#1d5174] text-white': !isDisabled,
                            'bg-gray-400 text-white cursor-not-allowed': isDisabled,
                        }
                    )}
                    onClick={() => {
                        if (!isDisabled) {
                            handleContinuePlan(noOfJobs);
                        }
                    }}
                >
                    Select
                </button>

            </div>
        </div>
    );
};

export default AnnualSubcriptionCard;
